import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_INGREDIENT_SPECIAL_CASE,
  UPSERT_INGREDIENT_SPECIAL_CASE,
} from '../action-types'
import { INGREDIENT_SPECIAL_CASE_INITIAL_STATE } from '../initial-states'

const ingredientSpecialCaseReducer = (
  state = INGREDIENT_SPECIAL_CASE_INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case FETCH_INGREDIENT_SPECIAL_CASE.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: undefined,
        }),
      )

    case FETCH_INGREDIENT_SPECIAL_CASE.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.ingredientSpecialCase,
        }),
      )

    case FETCH_INGREDIENT_SPECIAL_CASE.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: undefined,
        }),
      )

    case FETCH_INGREDIENT_SPECIAL_CASE.CLEANUP:
      return { ...INGREDIENT_SPECIAL_CASE_INITIAL_STATE }

    case UPSERT_INGREDIENT_SPECIAL_CASE.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: nextState.data,
        }),
      )

    case UPSERT_INGREDIENT_SPECIAL_CASE.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data:
            action.payload.data?.createIngredientSpecialCase ||
            action.payload.data?.updateIngredientSpecialCase,
        }),
      )

    case UPSERT_INGREDIENT_SPECIAL_CASE.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: nextState.data,
        }),
      )

    default:
      return state
  }
}

export default ingredientSpecialCaseReducer
